/**
 * Format a phone number as it is typed: (512) 677-8916. Keeps only the national
 * 10 digits (a leading country-code 1 is dropped) and grows the mask as digits arrive,
 * so deleting characters collapses cleanly rather than fighting the caret.
 */
export const formatPhoneInput = (value) => {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length > 10 && digits.startsWith('1')) digits = digits.slice(1);
  digits = digits.slice(0, 10);

  if (!digits) return '';
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const formatLeadPhone = (value) => {
  if (!value) return '-';

  const original = String(value).trim();
  const digits = original.replace(/\D/g, '');
  const nationalNumber = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (nationalNumber.length !== 10) return original;
  return `(${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
};
